import { useMemo } from 'react';
import { invokeEvent } from 'shared-base';
import Segment from '../Segment/Segment';
import classNames from './IndexSelector.module.css';
import { Wrapper } from './IndexSelector.style';

export type IndexSelectorProps = {
  total: number;
  value: SlotId | number;
  slotConfig: ISlotConfig;
  onChange: (value: SlotId) => void;
  onHover?: (id?: SlotId) => void;
};

export function IndexSelector(props: IndexSelectorProps) {
  const { total, value, slotConfig } = props;
  const { active = [] } = slotConfig ?? {};

  const data = useMemo(() => {
    return Array.from({ length: total }, (_, i) => ({
      value: String(i),
      label: String(i + 1),
      disabled: !active.includes(String(i) as any),
    }));
  }, [total, active]);

  function onHover(index?: number) {
    invokeEvent('slot/hover', { index });
  }

  function onChange(val: string) {
    props.onChange(val as SlotId);
  }

  return (
    <Wrapper className='IndexSelector-wrapper' data-testid='IndexSelector-wrapper'>
      <Segment
        className={classNames.segment}
        value={String(parseInt(value as any, 10))}
        data={data}
        onChange={onChange}
        onHover={onHover}
        activeSegments={active}
      />
    </Wrapper>
  );
}

export default IndexSelector;
